var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "unitary_form" },
    [
      _c("div", { staticClass: "ml-1 background--text text--lighten-5" }, [
        _vm._v("\n\t\tContrat *\n\t")
      ]),
      _vm._v(" "),
      _c("v-autocomplete", {
        staticClass: "grv-input",
        attrs: {
          dense: "",
          solo: "",
          items: _vm.legacy_contracts,
          "item-value": "id",
          "item-text": "name",
          name: "Contrat",
          rules: [_vm.checkRequired],
          "menu-props": { contentClass: "grv-menu" }
        },
        model: {
          value: _vm.form.parameters.legacy_contract_id,
          callback: function($$v) {
            _vm.$set(_vm.form.parameters, "legacy_contract_id", $$v)
          },
          expression: "form.parameters.legacy_contract_id"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ml-1 background--text text--lighten-5" }, [
        _vm._v("\n\t\tType d'asset *\n\t")
      ]),
      _vm._v(" "),
      _c("v-autocomplete", {
        staticClass: "grv-input",
        attrs: {
          dense: "",
          solo: "",
          name: "Type d'asset",
          rules: [_vm.checkRequired],
          "menu-props": { contentClass: "grv-menu" },
          items: _vm.source_types
        },
        model: {
          value: _vm.form.parameters.source_type,
          callback: function($$v) {
            _vm.$set(_vm.form.parameters, "source_type", $$v)
          },
          expression: "form.parameters.source_type"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ml-1 background--text text--lighten-5" }, [
        _vm._v("\n\t\tPrécision\n\t")
      ]),
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "grv-input",
        attrs: {
          dense: "",
          solo: "",
          name: "Précision",
          hint: "Une précision sur l'asset."
        },
        model: {
          value: _vm.form.parameters.precision,
          callback: function($$v) {
            _vm.$set(_vm.form.parameters, "precision", $$v)
          },
          expression: "form.parameters.precision"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ml-1 background--text text--lighten-5" }, [
        _vm._v("\n\t\tType de QC *\n\t")
      ]),
      _vm._v(" "),
      _c("v-select", {
        staticClass: "grv-input",
        attrs: {
          dense: "",
          solo: "",
          name: "Type de QC",
          rules: [_vm.checkRequired],
          "menu-props": { contentClass: "grv-menu" },
          items: _vm.qc_levels
        },
        model: {
          value: _vm.form.parameters.qc_level,
          callback: function($$v) {
            _vm.$set(_vm.form.parameters, "qc_level", $$v)
          },
          expression: "form.parameters.qc_level"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeb47d00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb47d00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_legacy.vue
// module id = null
// module chunks = 